import { NgModule } from '@angular/core';

import { SavingsTransactionsRoutingModule } from './savings-transactions-routing.module';
import { SavingsTransactionComponent } from './savings-transaction/savings-transaction.component';

import { SharedModule } from 'app/shared/shared.module';
import { SearchModule } from 'app/search/search.module';

@NgModule({
  declarations: [
    SavingsTransactionComponent,
  ],
  imports: [
    SharedModule,
    SavingsTransactionsRoutingModule,
    SearchModule
  ]
})
export class SavingsTransactionsModule { }
